moduleAlert = angular.module('alert.controller', [])
moduleAlert.controller "alertEditDialogCtrl", ["$scope", "$rootScope", "$timeout", "editorDragPanel", ($scope, $rootScope, $timeout, editorDragPanel) ->
  $scope.alertEditDialogShow = false
  bindExec = (e) ->
    if e.keyCode is 27
      $scope.cancel()
    $scope.$apply()
  bindHotKeys = ->
    $(document).bind "keyup", bindExec
  $rootScope.alertDialog = (params) ->
    $scope.alertEditDialogShow = true
    $scope.params = params
    bindHotKeys()
    return
  $scope.accept = ->
    $scope.params.accept()
    $scope.alertEditDialogShow = false
    $(document).unbind "keyup", bindExec
    return
  $scope.cancel = ->
    $scope.params.cancel() if $scope.params.cancel
    $scope.alertEditDialogShow = false
    $(document).unbind "keyup", bindExec
    return
]



// WEBPACK FOOTER //
// ./src/app/editor/alertEditDialog.controller.coffee